import type { VAxios } from '../../define/axios/Axios';

/**
 * pose 业务相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 查询我的姿势列表，支持分页
  getPoseList: (params) => defHttp.get({ url: `/aiad/poses`, params }),
  // 创建姿势
  createPose: (params) => defHttp.post({ url: `/aiad/poses`, params }),
  //  根据ID查询姿势信息
  getPose: (id) => defHttp.get({ url: `/aiad/poses/${id}` }),
  // 更新姿势
  updatePose: (id, params) => defHttp.put({ url: `/aiad/poses/${id}`, params }),
  // 删除姿势
  deletePose: (id) => defHttp.delete({ url: `/aiad/poses/${id}` }),
});
